import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTrialGuard } from '@/hooks/useTrialGuard';
import { useSimpleEmpresa } from '@/hooks/useSimpleEmpresa';
import TrialExpiredModal from '@/components/common/TrialExpiredModal';

/**
 * Provider que verifica el estado del trial y bloquea el acceso cuando expira
 */
const TrialGuardProvider = ({ children }) => {
  const { isInitialized } = useSimpleEmpresa();
  const { shouldBlockAccess, isTrialExpired, isFreePlan } = useTrialGuard();
  const [showTrialModal, setShowTrialModal] = useState(false);
  const location = useLocation();

  // Show loading spinner while initializing
  /*if (!isInitialized) {
    return <LoadingSpinner fullScreen />;
  }*/

  // Rutas que están permitidas incluso con trial expirado
  const allowedRoutes = [
    '/payments',
    '/auth',
    '/login',
    '/register',
    '/onboarding',
    '/profile'
  ];

  const isRouteAllowed = allowedRoutes.some(route => 
    location.pathname.startsWith(route)
  );

  useEffect(() => {
    // Solo mostrar modal si el trial está expirado, es plan gratuito, 
    // y no estamos en una ruta permitida
    if (shouldBlockAccess && isFreePlan && !isRouteAllowed) {
      //console.log('🚫 Trial expired - blocking access');
      setShowTrialModal(true);
    } else {
      setShowTrialModal(false);
    }
  }, [shouldBlockAccess, isFreePlan, isRouteAllowed]);

  // Render conditionally based on trial status
  return (
    <>
      {showTrialModal && (
        <>
          {/* Render children but dimmed */}
          <div className="opacity-20 pointer-events-none">
            {children}
          </div>
          
          {/* Trial expired modal */}
          <TrialExpiredModal
            isOpen={true}
            onClose={() => {
              // Only allow closing if trial is no longer expired
              if (!shouldBlockAccess) {
                setShowTrialModal(false);
              }
            }}
          />
        </>
      )}
      
      {/* Always render children, but conditionally show based on trial status */}
      <div className={showTrialModal ? 'hidden' : ''}>
        {children}
      </div>
    </>
  );
};

export default TrialGuardProvider;